import React, { useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}


export default function InventoryDialog(props) {

    const [open, setopen] = useState(false);
    const [all, setall] = useState(false);
    const [mode, setmode] = useState(false);
    const [data, setdata] = useState([]);
    const [rollback, setrollback] = useState(false);

    useEffect(() => {
        if (props.open === false) {
            setopen(props.open);
            props.fnc.current.wait(false);
        } else {
            setrollback(props.open === 2);
            setopen(true);
        }
    }, [props.open]);

    useEffect(() => {
        setdata(props.data);
    }, [props.data]);

    function OKClick() {
        if (checked.length === 0) {
            if (rollback)
                props.fnc.current.warnmsg("棚卸取消を行うデータを選択してください");
            else
                props.fnc.current.warnmsg("棚卸実行を行うデータを選択してください");
            return;
        }
        props.docmd(checked,mode,rollback);
    }
    const [checked, setChecked] = useState([]);
    function AllChecked(e) {
        setall(e.target.checked);
        if (e.target.checked) {
            let newvalue = [];
            for (let i = 0; i < data.length; i++) {
                newvalue.push(i);
            }
            setChecked(newvalue);
        } else {
            setChecked([]);
        }
    }
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };


    return (
        <div>
            <Dialog
                open={open}
                onClose={props.Close}
                disableBackdropClick={true}
                fullWidth={true}
                maxWidth={"sm"}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                aria-describedby="common-dialog-description"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-tagtool-title">
                    <span style={{ fontSize: 15 }}>{rollback ? '棚卸取消':'棚卸実行'}</span>
                </DialogTitle>
                <DialogContent>
                    {rollback ?
                        <div style={{ marginBottom: 10 }}>
                            棚卸取消を実行します。
                        </div>
                        :
                        <React.Fragment>
                            <div>
                                棚卸を実行します。選択した日付＋在庫拠点の在庫数が確定されます。
                            </div>
                            <FormControlLabel control={<Checkbox checked={mode} onChange={()=>setmode(!mode) }/>}
                            label={<span style={{ fontSize: 12 }}>棚卸の登録を行っていないデータの在庫を０にする（論理在庫を引き継ぐ場合未チェック）</span>} />
                        </React.Fragment>
                    }
                    <div style={{ marginLeft:20 }}>
                        <Checkbox
                            size="small"
                            checked={all}
                            onChange={AllChecked}
                            disableRipple
                        />
                        <span style={{ marginLeft:40 }}>棚卸日</span>
                        <span style={{ marginLeft: 30 }}>在庫拠点</span>
                    </div>
                    <List dense={true} sx={{ width: '100%', maxHeight: 200, bgcolor: 'background.paper', overflow: 'auto', position: 'relative' }}>
                        {data.map((value) => {
                            const labelId = `checkbox-list-label-${value.key}`;

                            return (
                                <ListItem
                                    key={value.key}
                                >
                                    <ListItemButton onClick={handleToggle(value.key)} sx={{ py: 0, height: 20 }}>
                                        <ListItemIcon>
                                            <Checkbox
                                                size="small"
                                                edge="start"
                                                checked={checked.indexOf(value.key) !== -1}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{ 'aria-labelledby': labelId }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText id={labelId} primary={`${value.date} | ${value.code} ${value.name}`} primaryTypographyProps={{ fontSize: 12 }}/>
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={OKClick} variant="outlined" color="primary">
                        実行
                    </Button>
                    <Button autoFocus onClick={props.Close} variant="outlined" color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}